import script from "./promotionCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./promotionCard.vue?vue&type=script&setup=true&lang=ts"

import "./promotionCard.vue?vue&type=style&index=0&id=92532dc8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92532dc8"]])

export default __exports__